import { render } from "./gmiIrrigationUnit.vue?vue&type=template&id=4b56c29f&scoped=true"
import script from "./gmiIrrigationUnit.vue?vue&type=script&lang=js"
export * from "./gmiIrrigationUnit.vue?vue&type=script&lang=js"

import "./gmiIrrigationUnit.vue?vue&type=style&index=0&id=4b56c29f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b56c29f"]])

export default __exports__